module.exports = __webpack_public_path__ + "ui-icons_ffd27a_256x240.png";


//////////////////
// WEBPACK FOOTER
// ./ui/src/vendor/jquery-ui/css/ui-lightness/images/ui-icons_ffd27a_256x240.png
// module id = 813
// module chunks = 1